module.exports = __webpack_public_path__ + "img/wodevip.f4c5b309.png";